import "./ProductSubmit.scss"
import React from "react"
import { observer } from "mobx-react"
import { Redirect } from "react-router-dom"
import { addProductStore } from "../../stores"

const ProductSubmit = () => {
  if (addProductStore.saving) {
    return (
      <div className="ProductSubmit">
        <h1>Creating your product...</h1>
        <ul>
          {addProductStore.filesProgress.size > 0 ? (
            addProductStore.filesProgress.entries().map(([file, progress]) => (
              <li key={file}>
                <span>
                  Uploading {file}, {Math.round(progress)}% progress
                </span>
              </li>
            ))
          ) : (
            <li>Generating print files...</li>
          )}
        </ul>
      </div>
    )
  } else {
    return <Redirect to="/products" />
  }
}

export default observer(ProductSubmit)



// WEBPACK FOOTER //
// ./src/products/add/ProductSubmit.js